<kendo-dialog title="Designating King Store" (close)="onCancel()">
  <div class="set-king-confirmation-message">
    <p>
      This will designate restaurant {{ restaurantToSetKing.name }} as your King
      for this tier.
    </p>

    <p>
      All restaurants in this tier will sync their prices to this King store.
    </p>
    <p>Are you sure you want to proceed?</p>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="onCancel()">No</button>
    <button kendoButton (click)="onProceed()" themeColor="primary">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
